module.exports = __webpack_public_path__ + "static/3-b64cb76252aed768daabc18e4ee45f89.jpg";